import { React, useState, Fragment } from 'react'
import { useHistory, Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import styles from './Auth.module.css'
import Constants from '../Constants'
import useAuth from '../Hooks/useAuth'
import useLoader from '../Hooks/useLoader'
import axios from 'axios'

const Auth = () => {

    const history = useHistory();
    const { token } = useAuth();
    const [loader, showLoader, hideLoader] = useLoader();

    //For Registration
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [gender, setGender] = useState('');
    const [age, setAge] = useState('');
    const [password, setPassword] = useState('');

    axios.defaults.withCredentials = true;
    const handleRegisterSubmit = async (e) => {
        e.preventDefault();

        if (!token || sessionStorage.getItem('token') === null) {
            toast.error('Token is Required')
        }
        else if (token !== sessionStorage.getItem('token')) {
            toast.error('Invalid Token')
        }
        else if (!name || !email || !age || !gender || !password) {
            toast.error('All Fields Are Required')
        }
        else {
            showLoader();
            const userData = { name, email, gender ,age,password }

            axios.get(Constants.url+'csrf-cookie').then(res => {
                axios.post(Constants.url + 'auth/add', JSON.stringify(userData),
                    {
                        headers : {
                            'Content-type': 'application/json',
                            'Accept': "application/json"
                        }
                    }
                )
                .then(res => {
                    let result = res.data
                    console.log(result);
                    hideLoader()
                    if (result.status === 'success') {
                        history.push('/login');
                        toast.success(result.message)
                    }
                    else {
                        toast.error(result.message)
                    }
                })
                .catch((err) => {
                    hideLoader();
                    toast.error(err.response.data.message);
                })
            });

            /* const response = await fetch(Constants.url + 'auth/add', {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(userData)
            });
            const result = await response.json();
            if (result.status === 'success') {
                hideLoader()
                toast.success(result.message)
                // history.push('/login');
            }
            else {
                hideLoader()
                toast.error(result.message)
            } */
        }
    }

    return (
        <Fragment>
            <div className={styles.authContainer} id="container">
                <div className={styles.signUpContainer} id="signInShow">
                    <form className={styles.form} onSubmit={handleRegisterSubmit}>
                        <h1 className={styles.heading}>Create Account</h1>
                        {/* <div id="getResponse" className={`alert ${classes}`} role="alert">{response}</div> */}
                        <input type="text" name="name" className={`form-control ${styles.authInput}`} placeholder="Name"
                            value={name} onChange={(e) => setName(e.target.value)} />
                        <input type="email" name="email" className={`form-control ${styles.authInput}`} placeholder="Email"
                            value={email} onChange={(e) => setEmail(e.target.value)} />
                        <input type="password" name="password" className={`form-control ${styles.authInput}`} placeholder="Password"
                            value={password} onChange={(e) => setPassword(e.target.value)} />
                        <input type="text" name="age" className={`form-control ${styles.authInput}`} placeholder="Age"
                            value={age} onChange={(e) => setAge(e.target.value)} />
                        <select className={`form-control ${styles.authInput}`} name="gender" value={gender} onChange={(e) => setGender(e.target.value)}>
                            <option value="">Select</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                        <button className={styles.authBtn}>Register</button>
                        <input type="hidden" name="token" value={token}></input>
                        <div className="clearfix"></div>
                        <Link to="/login" className={styles.userAcees}>Existing User? Click to Login</Link>
                        {/* <Link to="/" className={styles.forgotPass}>Forgot your password ?</Link> */}
                    </form>
                </div>
            </div>
            {loader}
        </Fragment >
    )
}

export default Auth
